import { SchemaFields } from "@redotech/redo-flows-core-schema-common/type-system/schema";

export const subscriptionUpsellSchemaFields = {
  hasSubscribableProduct: {
    dataType: "Boolean",
    documentation:
      "True when a Shopify selling plan is available for upsell in this context. Branch on this to gate subscription-upsell content.",
  },
  subscribableProductInCartName: {
    dataType: "Maybe Text",
    documentation:
      "Name of a product that the customer could be upsold into a subscription on. Empty when no subscribable product is available.",
  },
  subscriptionCheckoutUrl: {
    dataType: "Maybe Url",
    documentation:
      "Shopify checkout URL pre-filled with the subscribable line items. Empty when there are no subscribable products. Minted at send time from `subscribableLines` rather than at trigger time, because Storefront carts expire after ~30 days of inactivity.",
  },
  subscribableLines: {
    dataType: "Maybe Multiple Subscription Cart Line",
    documentation:
      "Subscribable cart lines (variantGid + sellingPlanGid + quantity) resolved at trigger time. Used at send time to mint a fresh Storefront checkout cart. Internal-only; not intended for template use.",
    hideFromInsertionModal: true,
    hideFromConditionStep: true,
  },
} as const satisfies SchemaFields;
